import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import "@fontsource/inter"

const displayName = import.meta.env.VITE_ASSISTANT_DISPLAY_NAME;
document.title = displayName || 'DriveSource';
const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
if (favicon) {
    if (displayName === 'HomeSource') {
        favicon.href = '/HomeSource%20Favicon%20Black.svg';
    } else {
        favicon.href = '/DriveSource%20Favicon%20Black.svg';
    }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);